var module = angular.module('octopusApp.projects');

module.directive('packageList', function($timeout, octopusRepository) {
    return {
        restrict: 'E',
        transclude: false,
        templateUrl: 'areas/projects/views/package_list.html',
        scope: {
            packages: '='
        },
        link: function(scope, element) {

            function loadPackagesForFeed(packages, feedId) {

                function LoadPackages(feed) {
                    return packages.map(function (pkg) {
                        return octopusRepository.Feeds.getNotes(feed, pkg.PackageId, pkg.Version).then(function (notes) {
                            pkg.ErrorNotes = null;
                            pkg.Notes = notes;
                            pkg.State = "ok";
                        }, function (err) {
                            pkg.ErrorNotes = err.ErrorMessage;
                            pkg.Notes = null;
                            pkg.State = "error";
                        });
                    });
                }
                octopusRepository.Feeds.get(feedId).then(LoadPackages);
            }

            function init() {
                if (!scope.packages) {
                    return;
                }

                _.each(_.groupBy(scope.packages, function(pkg) { return pkg.FeedId; }), loadPackagesForFeed);
            }

            $timeout(init, 200);
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/package_list.js
// module id = 545
// module chunks = 1